var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIconDisabled = function SvgFilterIconDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#027680",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 2.5c2.296 0 4.546.193 6.736.565a.92.92 0 0 1 .764.913v.87c0 .498-.198.975-.55 1.326l-4.526 4.527c-.351.351-.549.828-.549 1.326v2.44c0 .71-.401 1.359-1.037 1.676L8.125 17.5v-5.473c0-.498-.198-.974-.55-1.326L3.05 6.174A1.88 1.88 0 0 1 2.5 4.848v-.87c0-.45.32-.838.764-.913C5.454 2.693 7.704 2.5 10 2.5"
  })));
};
export { SvgFilterIconDisabled as ReactComponent };
export default __webpack_public_path__ + "adc4e1fc879be6d39f198c392b4325fa.svg";